import request from '@/axios'

// 案例列表
const getCaseList = (params) => {
  return request(`/admin/case`, params, 'get')
}
// 案例分类列表
const getCasecatList = (params) => {
  return request(`/admin/caseCat`, params, 'get')
}
// 资讯列表
const getArticleList = (params) => {
  return request(`/admin/article`, params, 'get')
}
// 员工名片列表
const getEmpCardList = (params) => {
  return request(`/admin/empCard/auth`, params, 'get')
}
// 商品列表
const getGoodsList = (params) => {
  return request(`/admin/goods`, params, 'get')
}
// 权限组列表
const getAuthorityList = (params) => {
  return request(`/admin/authority`, params, 'get')
}
// 员工权限列表
const getEmpPowerList = (params) => {
  return request(`/admin/employee`, params, 'get')
}
// 广告列表
const getAdverList = (params) => {
  return request(`/admin/advertisement`, params, 'get')
}
// 客户列表
const getCusList = (params) => {
  return request(`/admin/user`, params, 'get')
}
// 客户账户余额列表
const getCusAccountList = (params) => {
  return request(`/admin/user/getUserMoneyList`, params, 'get')
}
// 客户积分列表
const getCusPointList = (params) => {
  return request(`/admin/user/getUserPointChangeList`, params, 'get')
}
// 订单列表
const getOrderList = (params) => {
  return request(`/admin/order/verification`, params, 'get')
}
// 医脉订单列表
const getYmOrderList = (params) => {
  return request(`/admin/ymorder/verification`, params, 'get')
}
// 积分订单列表
const getOrderPointList = (params) => {
  return request(`/admin/order/point`, params, 'get')
}
// 活动管理
// 秒杀列表
const getSeckillList = (params) => {
  return request(`/admin/seckill`, params, 'get')
}
const getFirstOrderList = (params) => {
  return request(`/admin/firstOrder`, params, 'get')
}
// 秒杀购买记录
const getSeckillBuyList = (params) => {
  return request(`/admin/order/seckill`, params, 'get')
}
// 首单购买记录
const getFirstOrderBuyList = (params) => {
  return request(`/admin/order/firstorder`, params, 'get')
}
// 拼团列表
const getAssembleList = (params) => {
  return request(`/admin/groupBuy`, params, 'get')
}
// 拼团参与明细列表
const getAssembleJoinList = (params) => {
  return request(`/admin/groupBuyClumpDetailList`, params, 'get')
}
// 优惠券列表
const getCouponsList = (params) => {
  return request(`/admin/coupon`, params, 'get')
}
// 优惠券明细列表
const getCouponDetailList = (params) => {
  return request(`/admin/couponInfo`, params, 'get')
}
// 优惠券批量发券列表
const getUsersList = (params) => {
  return request(`/admin/coupon/users`, params, 'get')
}

// 投诉类型列表
const getComplaintTypeList = () => {
  return request(`/admin/complaintType`, {}, 'get')
}
// 投诉列表
const getComplaintList = (params) => {
  return request(`/admin/complaint`, params, 'get')
}
// 活动列表
const getActiveList = (params) => {
  return request(`/admin/activity/query`, params, 'get')
}
// 小程序版本列表
const getEditionList = (params) => {
  return request(`/admin/xcx/version`, params, 'get')
}
// 专家列表
const getSpeciaList = (params) => {
  return request(`/admin/specialist/getList`, params, 'get')
}
// 砍价列表
const getBargainList = (params) => {
  return request(`/admin/bargin`, params, 'get')
}
// 参与砍价列表
const getBargainedList = (params) => {
  return request(`/admin/barginJoinDetailList`, params, 'get')
}
// 专家页面 项目/案例 弹窗获取列表
const loadGoodsInExpert = (params) => {
  return request(`/admin/goods/specialistProject`, params, 'get')
}
const loadCaseInExpert = (params) => {
  return request(`/admin/case/getCases`, params, 'get')
}
// 客户绑定列表
const getCustomerBindList = (params) => {
  return request(`/admin/user/auth`, params, 'get')
}
// 客户积分变动明细
const getCustomerPointDetail = (params) => {
  return request(`/admin/user/getUserPointDetails`, params, 'get')
}
// 名片足迹列表
const getEmpCardFootprintList = (params) => {
  return request(`/admin/cardTrace/list`, params, 'get')
}
// 名片意向客户列表
const getEmpCardIntentCusList = (params) => {
  return request(`/admin/intentionUser/list`, params, 'get')
}
// 申请绑定记录
const getCusBindApplyList = (params) => {
  return request(`/admin/user`, { ...params, pageFlag: '1' }, 'get')
}

// 线下活动
const getOfflineActivityUsers = params => {
  return request(`/admin/offline-user`, params, 'get')
}

// 线下活动列表
const getOfflineActivity = params => {
  return request('/admin/offer-line-activity', params, 'get')
}

// 抽奖活动列表
const getRaffleList = params => {
  return request('/admin/offline-lottery-activity/page', params, 'get')
}

// 抽奖奖项列表
const getRafflePrizeList = params => {
  return request('/admin/offline-lottery/page', params, 'get')
}
// 抽奖奖项列表
const getIntegralGoodsList = params => {
  return request('/admin/offline-point-shop/page', params, 'get')
}

// 线下活动邀请码详情列表
const getOfflineActivityInviteCodes = params => {
  return request('/admin/invite-code', params, 'get')
}

// 线下活动参与员工列表
const getOfflineActivityEmp = params => {
  return request(`/admin/invite-code/employee`, params, 'get')
}

// 我的线下活动列表
const getOfflineActivityByMy = params => {
  return request('/admin/off-line-activity/employee/list', params, 'get')
}

// 我的线下活动邀请码详情列表
const getOfflineActivityInviteCodesByMy = params => {
  return request('/admin/invite-code/employee/list', params, 'get')
}
// 线下活动秒杀商品列表
const getSeckillGoodsList = (params) => {
  return request(`/admin/activitySeckill/${params.offlineAcId}`, params, 'get')
}

// 线下活动游戏列表
const getOfflineGame = params => {
  return request('/admin/offline-game/page', params, 'get')
}

// 线下活动拼团商品列表
const getAssembleGoodsList = params => {
  return request(`/admin/activityGroupBuy/${params.offlineAcId}`, params, 'get')
}

// 线下活动拼团商品详情中的拼团明细
const getActivityGroupBuyClumpDetailList = params => {
  return request(`/admin/activityGroupBuyClumpDetailList/${params.groupBuyId}/${params.offlineAcId}`, params, 'get')
}

// 线下活动消费排名列表
const getConsumptionRankList = params => {
  return request(`/admin/order/offlineSeckill/${params.offlineAcId}`, params, 'get')
}

// 线下活动照片墙
const loadPhotoWall = params => {
  return request(`/admin/offline-photos-wall/page`, params, 'get')
}

// 挂号科室列表
const getDepartmentList = params => {
  return request(`/admin/department/list`, params, 'get')
}

// 挂号费列表
const getRegistrationFeeList = params => {
  return request('/admin/registrationFee/list', params, 'get')
}
// 挂号记录
const registrationOrderList = (params) => {
  return request(`/admin/registrationOrder/list`, params, 'get')
}
// 09/08 分享增加三个接口
// 获取足迹
const getUserFoorPrintByCondition = (params) => {
  return request(`/admin/user/getUserFoorPrintByCondition`, params, 'get')
}
// 获取分享页用户列表
const getUserByCondition = (params) => {
  return request(`/admin/user/getUserByCondition`, params, 'get')
}

// 获取分享页用户列表
const getAllPresentProject = (params) => {
  return request(`/admin/getAllPresentProject`, params, 'get')
}

// 获取足迹详情
const getUserFoorPrintDetailByCondition = (params) => {
  return request(`/admin/user/getUserFoorPrintDetailByCondition`, params, 'get')
}

// 项目领取列表
const userPresent = (params) => {
  return request(`/admin/getPresentOfUser/${params.presentProjectId}`, params, 'get')
}

// qrcode
const qrcode = (params) => {
  return request(`/admin/qrcode`, params, 'get')
}

// 获取用户记录(新)
const getUserOperateRecordByCondition = (params) => {
  return request(`/admin/user/getUserOperateRecordByCondition`, params, 'get')
}

// 优惠券列表(首页模板精选)
const getCouponsList2 = (params) => {
  return request(`/admin/coupon/getCanCouponList`, params, 'get')
}

// 新增搜索图片库列表
const qrcodeposter = params => {
  return request(`/admin/qrcodeposter`, params, 'get')
}

// 新增咨询分类
const articleCat = params => {
  return request(`/admin/articleCat`, params, 'get')
}

// 新增渠道管理
const channel = params => {
  return request(`/admin/channel`, params, 'get')
}
// 兑换券管理
const couponProject = params => {
  return request(`/admin/couponProject`, params, 'get')
}
const couponProjectReceive = params => {
  return request(`/admin/couponProject/receive`, params, 'get')
}
const projectUserGoods = params => {
  return request(`/admin/couponProject/projectUserGoods`, params, 'get')
}
// 项目列表
const items = params => {
  return request(`/admin/item`, params, 'get')
}
// 预约明细列表
const appointment = params => {
  return request(`/admin/appointment`, params, 'get')
}
// 项目列表
const itemCat = params => {
  return request(`/admin/itemCat`, params, 'get')
}
// 评价列表
const evaluation = params => {
  return request(`/admin/evaluation`, params, 'get')
}
// 获取预检列表
const previewinfo = params => {
  return request(`/admin/previewinfo`, params, 'get')
}
const previewinfoemployee = params => {
  return request(`/admin/previewinfoemployee`, params, 'get')
}

// 分页获取疫情预约信息列表
const previewinfobreak = params => {
  return request(`/admin/previewinfobreak`, params, 'get')
}

export default {
  getCaseList,
  getCasecatList,
  getArticleList,
  getEmpCardList,
  getGoodsList,
  getAuthorityList,
  getEmpPowerList,
  getAdverList,
  getCusList,
  getCusAccountList,
  getCusPointList,
  getOrderList,
  getYmOrderList,
  getOrderPointList,
  getSeckillList,
  getFirstOrderList,
  getSeckillBuyList,
  getAssembleList,
  getAssembleJoinList,
  getCouponsList,
  getCouponDetailList,
  getUsersList,
  getComplaintTypeList,
  getComplaintList,
  getActiveList,
  getEditionList,
  getSpeciaList,
  getBargainList,
  getBargainedList,
  loadGoodsInExpert,
  loadCaseInExpert,
  getCustomerBindList,
  getCustomerPointDetail,
  getEmpCardFootprintList,
  getEmpCardIntentCusList,
  getCusBindApplyList,
  getOfflineActivityUsers,
  getOfflineActivity,
  getOfflineActivityEmp,
  getOfflineActivityInviteCodes,
  getOfflineActivityByMy,
  getOfflineActivityInviteCodesByMy,
  getSeckillGoodsList,
  getRaffleList,
  getRafflePrizeList,
  getOfflineGame,
  getAssembleGoodsList,
  getActivityGroupBuyClumpDetailList,
  getIntegralGoodsList,
  getConsumptionRankList,
  loadPhotoWall,
  getDepartmentList,
  registrationOrderList,
  getRegistrationFeeList,
  getUserFoorPrintByCondition,
  getUserByCondition,
  getAllPresentProject,
  getUserFoorPrintDetailByCondition,
  userPresent,
  qrcode,
  getUserOperateRecordByCondition,
  getCouponsList2,
  qrcodeposter,
  articleCat,
  channel,
  couponProject,
  couponProjectReceive,
  projectUserGoods,
  items,
  appointment,
  itemCat,
  evaluation,
  previewinfo,
  previewinfoemployee,
  getFirstOrderBuyList,
  previewinfobreak
}



// WEBPACK FOOTER //
// ./src/api/pagelist/index.js